import React from 'react'
import { useLocation } from 'react-router'

import { Tab } from '../../../design-system/Tab'
import { useBotId } from '../../../../store/flow'
import { DisableableLink } from '../../../Styleguide/DisableableLink'

export const AnalyticsTab: React.FC = () => {
  const botId = useBotId()
  const location = useLocation()

  const analyticsHref = `/bots/${botId}/analytics`
  const isAnalyticsInHref = location.pathname.endsWith(analyticsHref)

  return (
    <DisableableLink key="analytics-tab" to={analyticsHref}>
      <Tab size={18} label="Analytics" active={isAnalyticsInHref} />
    </DisableableLink>
  )
}
